import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "9.5",
  stroke: "currentColor"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.0368 5.66602V10.528C13.0368 11.0437 13.0085 11.5537 12.9518 12.058C12.9008 12.5623 12.8271 13.0865 12.7308 13.6305H11.1498C11.0535 13.0865 10.977 12.5623 10.9203 12.058C10.8693 11.5537 10.8438 11.0437 10.8438 10.528V5.66602H13.0368ZM10.5293 16.767C10.5293 16.58 10.5633 16.4043 10.6313 16.24C10.705 16.07 10.8041 15.9255 10.9288 15.8065C11.0535 15.6819 11.198 15.5855 11.3623 15.5175C11.5323 15.4438 11.7165 15.407 11.9148 15.407C12.1075 15.407 12.286 15.4438 12.4503 15.5175C12.6203 15.5855 12.7676 15.6819 12.8923 15.8065C13.017 15.9255 13.1161 16.07 13.1898 16.24C13.2635 16.4043 13.3003 16.58 13.3003 16.767C13.3003 16.9597 13.2635 17.1382 13.1898 17.3025C13.1161 17.4669 13.017 17.6114 12.8923 17.736C12.7676 17.855 12.6203 17.9485 12.4503 18.0165C12.286 18.0845 12.1075 18.1185 11.9148 18.1185C11.7165 18.1185 11.5323 18.0845 11.3623 18.0165C11.198 17.9485 11.0535 17.855 10.9288 17.736C10.8041 17.6114 10.705 17.4669 10.6313 17.3025C10.5633 17.1382 10.5293 16.9597 10.5293 16.767Z",
  fill: "currentColor"
}, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }